<template>
  <div v-rect-loading="loading" class="micro-site-list">
    <TableList
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @create="handleCreate"
    >
      <template #link="{ row }">
        <a class="link" target="_blank" :href="row.link" >{{ row.link }}</a>
      </template>
      <template #status="{ row, data }">
        <el-switch :value="data" @change="onEnabledChange($event, row)"></el-switch>
      </template>
    </TableList>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.postApplicant',
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.micrositeName`),
          dataKey: 'name',
          width: 100
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.micrositeUrl`),
          dataKey: 'link',
          slotName: 'link',
          cellClass: 'link-column',
          width: 200
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.micrositeStatus`),
          dataKey: 'status',
          slotName: 'status',
          width: 50
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: true,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('postApplicantManagement', ['searchMicroSite', 'updateMicroSite']),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchMicroSite()
        if (resp && resp.micro_site) {
          const url = `${window.location.origin}/v-admin/post-applicant-management/micro-site/detail/`
          this.listData = _.chain(resp.micro_site)
            .map(item => {
              return {
                ...item,
                status: item.status === 1,
                link: `${url}${item.url_code}`
              }
            })
            .orderBy(['status'], ['desc'])
            .value()
        }
      } finally {
        this.loading = false
      }
    },
    handleCreate () {
      this.$router.push({
        path: '/v-admin/post-applicant-management/micro-site/add',
        query: {
          tab: 'name'
        }
      })
    },
    handleEdit (rowData) {
      this.$router.push({
        path: `/v-admin/post-applicant-management/micro-site/edit/${rowData.id}`,
        query: {
          tab: 'name'
        }
      })
    },
    async onEnabledChange (status, rowData) {
      this.loading = true
      try {
        const statusData = {
          id: rowData.id,
          change_status: status
        }
        const resp = await this.updateMicroSite(statusData)
        if (resp) {
          rowData.status = statusData.change_status
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.micro-site-list {
  .link {
    color: #0096cc;
  }

  ::v-deep {
    td {
      &.link-column {
        color: #0096cc;
      }
    }
  }
}
</style>
